<button class='btn btn-info btn-block' type='button' (click)='companiesHouseLookup()'>Search Companies House</button>

@if (this.items.length > 0) {
  <app-container>
    <select class='form-control' (change)='onCompanySelected($event)'>
      <option value='-1'>Select a company</option>
      @for (item of this.items; track item) {
        <option [value]='item.company_number'>{{item.title}}</option>
      }
    </select>
  </app-container>
}